/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Backend,
    BackendFromJSON,
    BackendFromJSONTyped,
    BackendToJSON,
    FSProperties,
    FSPropertiesFromJSON,
    FSPropertiesFromJSONTyped,
    FSPropertiesToJSON,
    VolumeStatus,
    VolumeStatusFromJSON,
    VolumeStatusFromJSONTyped,
    VolumeStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface VolumeReference
 */
export interface VolumeReference {
    /**
     * 
     * @type {number}
     * @memberof VolumeReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof VolumeReference
     */
    readonly path?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VolumeReference
     */
    readonly nodes?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof VolumeReference
     */
    readonly displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeReference
     */
    readonly visualTag?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeReference
     */
    readonly isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeReference
     */
    readonly useForHomes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeReference
     */
    readonly useForWorkspaces?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VolumeReference
     */
    readonly type?: VolumeReferenceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeReference
     */
    readonly snmEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VolumeReference
     */
    readonly snfsName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeReference
     */
    readonly simulatedQuotas?: boolean;
    /**
     * 
     * @type {FSProperties}
     * @memberof VolumeReference
     */
    fsProperties?: FSProperties;
    /**
     * 
     * @type {Backend}
     * @memberof VolumeReference
     */
    backend?: Backend;
    /**
     * 
     * @type {VolumeStatus}
     * @memberof VolumeReference
     */
    status?: VolumeStatus;
    /**
     * 
     * @type {number}
     * @memberof VolumeReference
     */
    readonly cloudAccount?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum VolumeReferenceTypeEnum {
    Generic = 'generic',
    GenericMount = 'generic-mount',
    Snfs = 'snfs',
    Btrfs = 'btrfs',
    Lizardfs = 'lizardfs',
    Bcachefs = 'bcachefs',
    Onefs = 'onefs',
    Beegfs = 'beegfs',
    Cloud = 'cloud'
}

export function VolumeReferenceFromJSON(json: any): VolumeReference {
    return VolumeReferenceFromJSONTyped(json, false);
}

export function VolumeReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'nodes': !exists(json, 'nodes') ? undefined : json['nodes'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'visualTag': !exists(json, 'visual_tag') ? undefined : json['visual_tag'],
        'isDefault': !exists(json, 'is_default') ? undefined : json['is_default'],
        'useForHomes': !exists(json, 'use_for_homes') ? undefined : json['use_for_homes'],
        'useForWorkspaces': !exists(json, 'use_for_workspaces') ? undefined : json['use_for_workspaces'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'snmEnabled': !exists(json, 'snm_enabled') ? undefined : json['snm_enabled'],
        'snfsName': !exists(json, 'snfs_name') ? undefined : json['snfs_name'],
        'simulatedQuotas': !exists(json, 'simulated_quotas') ? undefined : json['simulated_quotas'],
        'fsProperties': !exists(json, 'fs_properties') ? undefined : FSPropertiesFromJSON(json['fs_properties']),
        'backend': !exists(json, 'backend') ? undefined : BackendFromJSON(json['backend']),
        'status': !exists(json, 'status') ? undefined : VolumeStatusFromJSON(json['status']),
        'cloudAccount': !exists(json, 'cloud_account') ? undefined : json['cloud_account'],
    };
}

export function VolumeReferenceToJSON(value?: VolumeReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fs_properties': FSPropertiesToJSON(value.fsProperties),
        'backend': BackendToJSON(value.backend),
        'status': VolumeStatusToJSON(value.status),
    };
}


